// src/pages/AdminUsers2.jsx
import React, { useEffect, useState } from 'react';
import PageLayout from '../components/PageLayout';
import Button from '../components/Button';
import { listEntites } from '../api/salles';
import {
  listUsers2,
  createUser2 as createUser,
  updateUser2 as updateUser,
  listProfiles,
  createProfile,
  updateProfile,
  addProfileToUser,
  createAdmin,
  updateAdmin
} from '../api/users';
import { useUser } from '../context/UserContext';
import AdminSettingsPanel from '../components/AdminSettingsPanel';
import toast from 'react-hot-toast';
import { Edit, CirclePlus, ChevronDown, ChevronRight, Users, KeyRound } from 'lucide-react';
import { createPortal } from 'react-dom';
export default function AdminUsers2() {
  const USER_ROLES = ['secretaire', 'infirmiere', 'medecin'/*, 'admin'*/];

  const userRolesColors = {
    infirmiere: 'bg-green-300',
    medecin: 'bg-red-300',
    secretaire: 'bg-indigo-300',
    admin: 'bg-amber-300',
  };

  const [error, setError] = useState('');
  const [openIds, setOpenIds] = useState(new Set());
  const [loading, setLoading] = useState(true);

  const [users, setUsers] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [entities, setEntities] = useState([]);


  const [addProfileToUserOpen, setAddProfileToUserOpen] = useState(false);
  const [addProfileToUserForm, setAddProfileToUserForm] = useState({});
  const [addProfileSearch, setAddProfileSearch] = useState('');

  const [createProfileOpen, setCreateProfileOpen] = useState(false);
  const [createProfileForm, setCreateProfileForm] = useState({actif: true, default_etablissement_id: ''});
  const [updateProfileOpen, setUpdateProfileOpen] = useState(false);
  const [updateProfileForm, setUpdateProfileForm] = useState({});

  const [createUserOpen, setCreateUserOpen] = useState(false);
  const [createUserForm, setCreateUserForm] = useState({actif: true, role: USER_ROLES[0]});
  const [updateUserOpen, setUpdateUserOpen] = useState(false);
  const [updateUserForm, setUpdateUserForm] = useState({});
  const [updatePasswordOpen, setUpdatePasswordOpen] = useState(false);
  const [updatePasswordForm, setUpdatePasswordForm] = useState({});

  const [createAdminOpen, setCreateAdminOpen] = useState(false);
  const [createAdminForm, setCreateAdminForm] = useState({ actif: true });
  const [updateAdminOpen, setUpdateAdminOpen] = useState(false);
  const [updateAdminForm, setUpdateAdminForm] = useState({});

  const { logout } = useUser();

  const handleSetUpdateProfileForm = (profile, entity) => {
    setUpdateProfileForm({
      nom: profile.profile_nom,
      prenom: profile.profile_prenom,
      default_etablissement_id: profile.profile_default_etablissement_id,
      actif: profile.profile_actif,
      profile_id: profile.profile_id,
      entity_etablissements: entity.etablissements,
      pentagramme: profile.profile_pentagramme,
    });
  };

  const handleSetUpdateUserForm = (user) => {
    setUpdateUserForm({
      identifiant: user.user_identifiant,
      libelle: user.user_libelle,
      role: user.user_role,
      actif: user.user_actif,
      user_id: user.user_id,
    });
  };

  const handleSetUpdateAdminForm = (user) => {
    setUpdateAdminForm({
      identifiant: user.user_identifiant,
      role: user.user_role,
      actif: user.user_actif,
      user_id: user.user_id,
      nom: user.profiles[0].profile_nom,
      prenom: user.profiles[0].profile_prenom,
      pentagramme: user.profiles[0].profile_pentagramme,
    });
  };

  const handleSetUpdatePasswordForm = (user) => {
    setUpdatePasswordForm({
      libelle: user.user_libelle,
      user_id: user.user_id,
    });
  };

  const handleSetAddProfileToUserForm = (user, entity) => {
    const entityProfiles = profiles.filter((p) => p.profile_entity_id === entity.entite_id);
    // Si aucun profil ne correspond à l'entité (entite_id null ou non renseigné),
    // on affiche tous les profils pour permettre l'affectation
    const availableProfiles = entityProfiles.length > 0 ? entityProfiles : profiles;
    setAddProfileToUserForm({
      entity_profiles: availableProfiles,
      user_profiles: user.profiles,
      user_id: user.user_id,
      user_libelle: user.user_libelle,
    });
  };

  function toggle(id) {
    setOpenIds((prev) => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  }

  function toggleProfile(profile, checked) {
    setAddProfileToUserForm((prev) => {
      const nextProfiles = [...prev.user_profiles];
      const index = nextProfiles.findIndex((p) => p.profile_id === profile.profile_id);
      if (checked && index === -1) {
        nextProfiles.push(profile);
      }
      if (!checked && index !== -1) {
        nextProfiles.splice(index, 1);
      }
      return {
        ...prev,
        user_profiles: nextProfiles,
      };
    });
  }

  function UserCards({userRows, entity}) {
    return userRows.map((user) => {
      const isOpen = openIds.has(user.user_id);
      return (
        <div
          key={user.user_id}
          className="bg-white rounded-xl shadow p-3 grid grid-cols-1 md:grid-cols-2"
        >
          <button
            onClick={() => toggle(user.user_id)}
            className="flex-1 text-left flex flex-wrap items-center gap-3 col-span-1"
            title="Ouvrir / fermer"
          >
            <span className="inline-block w-5 text-slate-500">
              {isOpen ? <ChevronDown strokeWidth={3} /> : <ChevronRight strokeWidth={3} />}
            </span>
            <div className="font-medium truncate">{user.user_libelle} </div>
            <div>
              <span
                className={`shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full ${userRolesColors[user.user_role]} text-black text-xs`}
              >
                {user.user_role}
              </span>{' '}
              <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-200 text-slate-700 text-xs">
                {user.profiles?.length} {' personne' + (user.profiles?.length > 1 ? 's' : '')}
              </span>{' '}
              <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-blue-200 text-slate-700 text-xs">
                {user.user_actif ? 'Actif' : 'Inactif'}
              </span>
              <span className="md:inline ml-2 text-xs text-gray-500">
                ({user.user_identifiant})
              </span>
            </div>
          </button>

          <div className="flex items-center justify-between col-span-1 gap-2">
            <div className="flex-shrink-0 flex gap-2">
              <Button
                onClick={() => {
                  setAddProfileSearch('');
                  setAddProfileToUserOpen(true);
                  handleSetAddProfileToUserForm(user, entity);
                }}
              >
                <Users size={20} className="inline-block" />
                <span className="ml-0.5">Gérer les personnes</span>
              </Button>

              <Button
                variant="danger"
                onClick={() => {
                  setUpdateUserOpen(true);
                  handleSetUpdateUserForm(user);
                }}
              >
                <Edit size={20} className="inline-block" />
                <span className="hidden md:inline ml-0.5">Modifier le rôle</span>
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setUpdatePasswordOpen(true);
                  handleSetUpdatePasswordForm(user);
                }}
              >
                <KeyRound size={20} className="inline-block" />
                <span className="hidden md:inline ml-0.5">Modifier le mdp</span>
              </Button>
            </div>
          </div>

          {isOpen && (
            <div className="mt-3 gap-2 md:col-span-2 grid grid-cols-1 md:grid-cols-2 auto-rows-fr">
              {user.profiles?.length === 0 ? (
                <p className="italic text-sm text-gray-500 col-span-2">
                  Aucune personne liée à ce rôle
                </p>
              ) : (
                user.profiles?.map((profile) => (
                  <div
                    key={profile.profile_id}
                    className="bg-gray-300 rounded-xl shadow p-3 col-span-2 md:col-span-1 h-full"
                  >
                    <div className="flex items-center justify-between gap-2">
                      <div className="min-w-0">
                        <div className="font-medium ">
                          {profile.profile_nom + ' ' + profile.profile_prenom}
                          <span className="hidden md:inline ml-2 text-xs text-gray-600">
                            ({profile.profile_id})
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          <div className="flex items-center justify-between gap-2"></div>
        </div>
      );
    });
  }

  function AdminCards({ userRows }) {
    return userRows.map((user) => {
      const profile = user.profiles[0];
      return (
        <div
          key={profile.profile_id}
          className="bg-white rounded-xl shadow p-3 grid grid-cols-1 md:grid-cols-10 gap-2"
        >
          <div className="col-span-8 grid grid-cols-1">
            <div className="flex-1 text-left flex flex-wrap items-center gap-3 ">
              <div className="font-medium truncate">
                {profile.profile_nom + ' ' + profile.profile_prenom + ' [' + profile.profile_pentagramme + '] '}
              </div>
              <div>
                <span
                  className={`shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full ${userRolesColors[user.user_role]} text-black text-xs`}
                >
                  {user.user_role}
                </span>{' '}
                <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-blue-400 text-white text-xs">
                  {user.user_actif ? 'Actif' : 'Inactif'}
                </span>
                <span className="md:inline ml-2 text-xs text-gray-500">
                  ({user.user_identifiant})
                </span>
              </div>
            </div>
          </div>
          <div className="col-span-2 flex-shrink-0 flex gap-2">
            <Button
              variant="danger"
              onClick={() => {
                setUpdateAdminOpen(true);
                handleSetUpdateAdminForm(user);
              }}
            >
              <Edit size={20} className="inline-block" />
              <span className="hidden md:inline ml-0.5">Modifier l'admin</span>
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                setUpdatePasswordOpen(true);
                handleSetUpdatePasswordForm(user);
              }}
            >
              <KeyRound size={20} className="inline-block" />
              <span className="hidden md:inline ml-0.5">Modifier le mdp</span>
            </Button>
          </div>
        </div>
      );
    });
  }

  function ProfileCards({profileRows, entity}) {
    return profileRows.map((profile) => {
      return (
        <div
          key={profile.profile_id}
          className="bg-white rounded-xl shadow p-3 grid grid-cols-1 md:grid-cols-7 gap-2"
        >
          <div className="col-span-5 grid grid-cols-1">
            <div className="flex-1 text-left flex flex-wrap items-center gap-3 ">
              <div className="font-medium truncate">
                {profile.profile_nom + ' ' + profile.profile_prenom + ' [' + profile.profile_pentagramme + '] '}
              </div>
              <div>
                <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-blue-400 text-white text-xs">
                  {profile.profile_actif ? 'Actif' : 'Inactif'}
                </span>
              </div>
            </div>
            <div className="hidden">
              <span>
                établissement par défaut:{' '}
                {
                  profile.profile_default_etablissement_id
                    ?
                    entity.etablissements.find(e => e.etablissement_id === profile.profile_default_etablissement_id)?.etablissement_libelle
                    :
                    'Aucun'
                }
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between col-span-2 gap-2">
            <div className="min-w-0"></div>
            <div className="flex-shrink-0 flex gap-2">
              <Button
                variant="danger"
                onClick={() => {
                  setUpdateProfileOpen(true);
                  handleSetUpdateProfileForm(profile, entity);
                }}
              >
                <Edit size={20} className="inline-block" />
                <span className="hidden md:inline ml-0.5">Modifier le profile</span>
              </Button>
            </div>
          </div>
        </div>
      );
    });
  }

  const refresh = async () => {
    setError('');
    setLoading(true);
    try {
      const data = await listEntites();
      const fUsers = await listUsers2();
      const fProfiles = await listProfiles();

      setEntities(data);
      setUsers(fUsers);
      setProfiles(fProfiles);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const onCreateProfile= async (e) => {
    e.preventDefault();

    try {
      if (!createProfileForm.nom?.trim()) {
        throw new Error('Nom requis');
      }
      if (!createProfileForm.prenom?.trim()) {
        throw new Error('Prenom requis');
      }
      if (!createProfileForm.pentagramme?.trim()) {
        throw new Error('Pentagramme requis');
      }
      if (!createProfileForm.entity_id?.trim()) {
        throw new Error('Entité requise');
      }
      const payload = { ...createProfileForm };
      await createProfile(payload);
      toast.success('Profile créé');
      setCreateProfileOpen(false);
      setCreateProfileForm({
        actif: true,
        default_etablissement_id: ''
      });
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onUpdateProfile= async (e) => {
    e.preventDefault();

    try {
      if (!updateProfileForm.nom?.trim()) {
        throw new Error('Nom requis');
      }
      if (!updateProfileForm.prenom?.trim()) {
        throw new Error('Prenom requis');
      }
      if (!updateProfileForm.pentagramme?.trim()) {
        throw new Error('Pentagramme requis');
      }
      const payload = { ...updateProfileForm };
      await updateProfile(updateProfileForm.profile_id, payload);
      toast.success('Profile mis à jour');
      setUpdateProfileOpen(false);
      setUpdateProfileForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onCreateUser = async (e) => {
    e.preventDefault();

    try {
      if (!createUserForm.identifiant?.trim()) {
        throw new Error('Identifiant requis');
      }
      if (!createUserForm.libelle?.trim()) {
        throw new Error('Libellé requis');
      }
      if (!createUserForm.role?.trim()) {
        throw new Error('Rôle requis');
      }
      if (!createUserForm.entity_id?.trim()) {
        throw new Error('Entité requise');
      }
      if (!createUserForm.password?.trim()) {
        throw new Error('Mot de passe requis');
      }
      const payload = { ...createUserForm };
      await createUser(payload);
      toast.success('User créé');
      setCreateUserOpen(false);
      setCreateUserForm({
        actif: true,
      });
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onUpdateUser = async (e) => {
    e.preventDefault();
    try {
      if (!updateUserForm.identifiant?.trim()) {
        throw new Error('Identifiant requis');
      }
      if (!updateUserForm.libelle?.trim()) {
        throw new Error('Libellé requis');
      }
      const payload = { ...updateUserForm };
      await updateUser(updateUserForm.user_id,payload);
      toast.success('Utilisateur mis à jour');
      setUpdateUserOpen(false);
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onCreateAdmin = async (e) => {
    e.preventDefault();

    try {
      if (!createAdminForm.identifiant?.trim()) {
        throw new Error('Identifiant requis');
      }
      if (!createAdminForm.nom?.trim()) {
        throw new Error('Nom requis');
      }
      if (!createAdminForm.prenom?.trim()) {
        throw new Error('Prénom requis');
      }
      if (!createAdminForm.pentagramme?.trim()) {
        throw new Error('Pentagramme requis');
      }
      if (!createAdminForm.password?.trim()) {
        throw new Error('Mot de passe requis');
      }
      const payload = { ...createAdminForm };
      await createAdmin(payload);
      toast.success('Admin créé');
      setCreateAdminOpen(false);
      setCreateAdminForm({
        actif: true,
      });
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onUpdateAdmin = async (e) => {
    e.preventDefault();

    try {
      if (!updateAdminForm.identifiant?.trim()) {
        throw new Error('Identifiant requis');
      }
      if (!updateAdminForm.nom?.trim()) {
        throw new Error('Nom requis');
      }
      if (!updateAdminForm.prenom?.trim()) {
        throw new Error('Prénom requis');
      }
      if (!updateAdminForm.pentagramme?.trim()) {
        throw new Error('Pentagramme requis');
      }

      const payload = { ...updateAdminForm };
      await updateAdmin(updateAdminForm.user_id, payload);
      toast.success('Admin mis à jour');
      setUpdateAdminOpen(false);
      setUpdateAdminForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onUpdatePassword = async (e) => {
    e.preventDefault();
    try {
      if (!updatePasswordForm.password) {
        throw new Error('Mot de passe requis');
      }
      const payload = { ...updatePasswordForm };
      await updateUser(updatePasswordForm.user_id,payload);
      toast.success('Mot de passe mis à jour');
      setUpdatePasswordOpen(false);
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onAddProfileToUser = async (e) => {
    e.preventDefault();
    try {
      if (!addProfileToUserForm.user_id?.trim()) {
        throw new Error('user_id requis');
      }
      if (!Array.isArray(addProfileToUserForm.user_profiles)) {
        throw new Error('user_profiles requis');
      }

      const payload = { ...addProfileToUserForm };
      await addProfileToUser(addProfileToUserForm.user_id, payload);
      toast.success('Profiles du user modifiés');
      setAddProfileToUserOpen(false);
      setAddProfileToUserForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <PageLayout title="Administration — Users">
      {createProfileOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setCreateProfileOpen(false)}
            />
            <form
              onSubmit={onCreateProfile}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-7 gap-2"
            >
              <div className="md:col-span-7">
                <h2 className="text-lg font-semibold mb-1">
                  Ajouter une nouvelle personne à{' '}
                  <span className="bg-blue-200 pr-1 pl-1">{createProfileForm.entity_libelle}</span>
                </h2>
              </div>
              <div className="md:col-span-2">
                <label>Nom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Nom"
                  value={createProfileForm.nom}
                  onChange={(e) => setCreateProfileForm((f) => ({ ...f, nom: e.target.value }))}
                />
              </div>
              <div className="md:col-span-2">
                <label>Prénom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Prénom"
                  value={createProfileForm.prenom}
                  onChange={(e) => setCreateProfileForm((f) => ({ ...f, prenom: e.target.value }))}
                />
              </div>
              <div className="md:col-span-2">
                <label>Pentagramme</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Pentagramme"
                  value={createProfileForm.pentagramme}
                  onChange={(e) =>
                    setCreateProfileForm((f) => ({ ...f, pentagramme: e.target.value }))
                  }
                />
              </div>
              <div className="md:col-span-1">
                <label>Actif</label>
                <input
                  className="flex items-center gap-2"
                  type="checkbox"
                  checked={createProfileForm.actif}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setCreateProfileForm((f) => ({ ...f, actif: checked }));
                  }}
                />
              </div>
              <div className="hidden md:inline-block md:col-span-2"></div>
              <div className="md:col-span-5 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setCreateProfileOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Ajouter la personne</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updateProfileOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdateProfileOpen(false)}
            />
            <form
              onSubmit={onUpdateProfile}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-7 gap-2"
            >
              <div className="md:col-span-7">
                <h2 className="text-lg font-semibold mb-1">
                  Modification des informations de{' '}
                  <span className="bg-blue-200 pr-1 pl-1">
                    {updateProfileForm.nom + ' ' + updateProfileForm.prenom}
                  </span>
                </h2>
              </div>
              <div className="md:col-span-2">
                <label>Nom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Nom"
                  value={updateProfileForm.nom}
                  onChange={(e) => setUpdateProfileForm((f) => ({ ...f, nom: e.target.value }))}
                />
              </div>
              <div className="md:col-span-2">
                <label>Prénom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Prénom"
                  value={updateProfileForm.prenom}
                  onChange={(e) => setUpdateProfileForm((f) => ({ ...f, prenom: e.target.value }))}
                />
              </div>
              <div className="md:col-span-2">
                <label>Pentagramme</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="pentagramme"
                  value={updateProfileForm.pentagramme}
                  onChange={(e) =>
                    setUpdateProfileForm((f) => ({ ...f, pentagramme: e.target.value }))
                  }
                />
              </div>
              <div className="md:col-span-1">
                <label>Actif</label>
                <input
                  className="flex items-center gap-2"
                  type="checkbox"
                  checked={updateProfileForm.actif}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setUpdateProfileForm((f) => ({ ...f, actif: checked }));
                  }}
                />
              </div>
              <div className="hidden md:inline-block md:col-span-2"></div>
              <div className="md:col-span-5 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdateProfileOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier la personne</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {createUserOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setCreateUserOpen(false)}
            />
            <form
              onSubmit={onCreateUser}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-9 gap-2"
            >
              <div className="md:col-span-12">
                <h2 className="text-lg font-semibold mb-1">
                  Nouveau Rôle pour{' '}
                  <span className="bg-blue-200 pr-1 pl-1">{createUserForm.entity_libelle}</span>
                </h2>
              </div>

              <div className="md:col-span-2">
                <label>Identifiant</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Identifiant"
                  value={createUserForm.identifiant}
                  onChange={(e) =>
                    setCreateUserForm((f) => ({ ...f, identifiant: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-2">
                <label>Libellé</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Libellé"
                  value={createUserForm.libelle}
                  onChange={(e) => setCreateUserForm((f) => ({ ...f, libelle: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>MDP</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Mot de passe"
                  type="password"
                  value={createUserForm.password}
                  onChange={(e) => setCreateUserForm((f) => ({ ...f, password: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>Rôle</label>
                <select
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  value={createUserForm.role}
                  onChange={(e) => setCreateUserForm((f) => ({ ...f, role: e.target.value }))}
                >
                  {USER_ROLES.map((r) => (
                    <option key={r} value={r}>
                      {r}
                    </option>
                  ))}
                </select>
              </div>

              <div className="md:col-span-1">
                <label>Actif</label>
                <input
                  className="flex items-center gap-2"
                  type="checkbox"
                  checked={createUserForm.actif}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setCreateUserForm((f) => ({ ...f, actif: checked }));
                  }}
                />
              </div>
              <div className="hidden md:col-span-6 md:inline-block"></div>
              <div className="md:col-span-6 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setCreateUserOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Ajouter le rôle</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updateUserOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdateUserOpen(false)}
            />
            <form
              onSubmit={onUpdateUser}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-9 gap-2"
            >
              <div className="md:col-span-12">
                <h2 className="text-lg font-semibold mb-1">
                  Modifier le rôle{' '}
                  <span className="bg-blue-200 pr-1 pl-1">{updateUserForm.libelle}</span>
                </h2>
              </div>

              <div className="md:col-span-3">
                <label>Identifiant</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Identifiant"
                  value={updateUserForm.identifiant}
                  onChange={(e) =>
                    setUpdateUserForm((f) => ({ ...f, identifiant: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-3">
                <label>Libellé</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Libellé"
                  value={updateUserForm.libelle}
                  onChange={(e) => setUpdateUserForm((f) => ({ ...f, libelle: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>Rôle</label>
                <span
                  className={
                    'text-center p-1 text-black block ' + userRolesColors[updateUserForm.role]
                  }
                >
                  {updateUserForm.role}
                </span>
              </div>

              <div className="md:col-span-1">
                <label>Actif</label>
                <input
                  className="flex items-center gap-2"
                  type="checkbox"
                  checked={updateUserForm.actif}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setUpdateUserForm((f) => ({ ...f, actif: checked }));
                  }}
                />
              </div>
              <div className="hidden md:inline-block md:col-span-6"></div>
              <div className="md:col-span-6 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdateUserOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier le rôle</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {createAdminOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setCreateAdminOpen(false)}
            />
            <form
              onSubmit={onCreateAdmin}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-11 gap-2"
            >
              <div className="md:col-span-11">
                <h2 className="text-lg font-semibold mb-1">Nouvel Admin</h2>
              </div>

              <div className="md:col-span-2">
                <label>Identifiant</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Identifiant"
                  value={createAdminForm.identifiant}
                  onChange={(e) =>
                    setCreateAdminForm((f) => ({ ...f, identifiant: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-2">
                <label>Nom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Nom"
                  value={createAdminForm.nom}
                  onChange={(e) => setCreateAdminForm((f) => ({ ...f, nom: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>Prénom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Prénom"
                  value={createAdminForm.prenom}
                  onChange={(e) => setCreateAdminForm((f) => ({ ...f, prenom: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>Pentagramme</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Pentagramme"
                  value={createAdminForm.pentagramme}
                  onChange={(e) =>
                    setCreateAdminForm((f) => ({ ...f, pentagramme: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-2">
                <label>MDP</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Mot de passe"
                  type="password"
                  value={createAdminForm.password}
                  onChange={(e) => setCreateAdminForm((f) => ({ ...f, password: e.target.value }))}
                />
              </div>

              <div className="md:col-span-1">
                <label>Actif</label>
                <input
                  className="flex items-center gap-2"
                  type="checkbox"
                  checked={createAdminForm.actif}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setCreateAdminForm((f) => ({ ...f, actif: checked }));
                  }}
                />
              </div>
              <div className="hidden md:inline-block md:col-span-5"></div>
              <div className="md:col-span-6 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setCreateAdminOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Ajouter l'Admin</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updateAdminOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdateAdminOpen(false)}
            />
            <form
              onSubmit={onUpdateAdmin}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-7 gap-2"
            >
              <div className="md:col-span-12">
                <h2 className="text-lg font-semibold mb-1">
                  Mettre à jour {`${updateAdminForm.nom} ${updateAdminForm.prenom}`}
                </h2>
              </div>

              <div className="md:col-span-2">
                <label>Identifiant</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Identifiant"
                  value={updateAdminForm.identifiant}
                  onChange={(e) =>
                    setUpdateAdminForm((f) => ({ ...f, identifiant: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-2">
                <label>Nom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Nom"
                  value={updateAdminForm.nom}
                  onChange={(e) => setUpdateAdminForm((f) => ({ ...f, nom: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>Prénom</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Prénom"
                  value={updateAdminForm.prenom}
                  onChange={(e) => setUpdateAdminForm((f) => ({ ...f, prenom: e.target.value }))}
                />
              </div>

              <div className="md:col-span-2">
                <label>Pentagramme</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Pentagramme"
                  value={updateAdminForm.pentagramme}
                  onChange={(e) =>
                    setUpdateAdminForm((f) => ({ ...f, pentagramme: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-1">
                <label>Actif</label>
                <input
                  className="flex items-center gap-2"
                  type="checkbox"
                  checked={updateAdminForm.actif}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setUpdateAdminForm((f) => ({ ...f, actif: checked }));
                  }}
                />
              </div>
              <div className="hidden md:inline-block md:col-span-6"></div>
              <div className="md:col-span-6 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdateAdminOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier l'Admin</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updatePasswordOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdatePasswordOpen(false)}
            />
            <form
              onSubmit={onUpdatePassword}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1gap-2"
            >
              <div>
                <h2 className="text-lg font-semibold mb-1">
                  Modifier le mot de passe de{' '}
                  <span className="bg-blue-200 pr-1 pl-1">{updatePasswordForm.libelle}</span>
                </h2>
              </div>

              <div>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Mot de passe"
                  type="password"
                  onChange={(e) =>
                    setUpdatePasswordForm((f) => ({ ...f, password: e.target.value }))
                  }
                />
              </div>

              <div className="flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdatePasswordOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier le mot de passe</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {addProfileToUserOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setAddProfileToUserOpen(false)}
            />
            <form
              onSubmit={onAddProfileToUser}
              className="relative z-10 mx-3 rounded-2xl bg-white w-max shadow-xl p-4 grid grid-cols-1 gap-2"
            >
              <h2 className="md:col-span-7 text-lg font-semibold mb-1">
                Gérer les personnes liées au rôle{' '}
                <span className="bg-gray-300">{addProfileToUserForm.user_libelle}</span>
              </h2>

              {addProfileToUserForm.entity_profiles?.length > 0 ? (() => {
                const q = addProfileSearch.toLowerCase().trim();
                const checked = addProfileToUserForm.user_profiles ?? [];
                const filtered = addProfileToUserForm.entity_profiles.filter((p) => {
                  if (!q) return true;
                  return (p.profile_nom + ' ' + p.profile_prenom + ' ' + (p.profile_pentagramme || '')).toLowerCase().includes(q);
                });
                return (
                  <>
                    <input
                      type="text"
                      autoFocus
                      placeholder="Rechercher une personne…"
                      value={addProfileSearch}
                      onChange={(e) => setAddProfileSearch(e.target.value)}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                    />
                    <div className="md:col-span-7 grid grid-cols-1 gap-1 max-h-72 overflow-y-auto pr-1">
                      {filtered.length === 0 ? (
                        <p className="italic text-sm text-gray-500">Aucun résultat</p>
                      ) : (
                        filtered.map((profile) => (
                          <label key={profile.profile_id} className="flex items-center gap-2 py-1 px-2 rounded hover:bg-gray-100 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={checked.some((mProfile) => mProfile.profile_id === profile.profile_id)}
                              onChange={(e) => toggleProfile(profile, e.target.checked)}
                            />
                            <span className="flex-1">{profile.profile_nom} {profile.profile_prenom}</span>
                            {profile.profile_pentagramme && (
                              <span className="text-xs text-gray-400">[{profile.profile_pentagramme}]</span>
                            )}
                          </label>
                        ))
                      )}
                    </div>
                    <div className="text-xs text-gray-400">
                      {checked.length} sélectionné{checked.length > 1 ? 's' : ''}
                      {q && ` · ${filtered.length} résultat${filtered.length > 1 ? 's' : ''}`}
                    </div>
                    <div className="md:col-span-7 flex justify-end gap-2 mt-2">
                      <Button type="button" onClick={() => setAddProfileToUserOpen(false)}>
                        Annuler
                      </Button>
                      <Button type="submit">Mettre à jour</Button>
                    </div>
                  </>
                );
              })() : (
                <>
                  <div className="md:col-span-7 grid grid-cols-1 gap-2">
                    <p className="italic text-sm text-gray-600">
                      Aucune personne disponible. Ajoutez d'abord des personnes à cette entité.
                    </p>
                  </div>
                  <div className="md:col-span-7 flex justify-end gap-2 mt-2">
                    <Button type="button" onClick={() => setAddProfileToUserOpen(false)}>
                      Fermer
                    </Button>
                  </div>
                </>
              )}
            </form>
          </div>,
          document.body,
        )}

      {loading ? (
        <p className="text-sm text-gray-500">Chargement…</p>
      ) : error ? (
        <p className="text-sm text-red-600">{error}</p>
      ) : users.length === 0 ? (
        <p className="text-sm text-gray-500">Aucun user</p>
      ) : (
        <>
          <div className="mt-3">
            <div className="px-4 pt-2 pb-2 items-center justify-between mb-3 flex">
              <h1 className="text-xl font-semibold">Gestion des utilisateurs</h1>
              <div className="flex gap-2">
                <Button onClick={logout}>Se déconnecter</Button>
              </div>
            </div>
            {entities.map((entity) => {
              const isOpen = openIds.has(entity.entite_id);
              const entityUsers = users.filter((u) => u.user_entity_id === entity.entite_id);
              const entityProfiles = profiles.filter(
                (p) => p.profile_entity_id === entity.entite_id,
              );
              return (
                <div
                  key={entity.entite_id}
                  className="mb-3 space-y-2 bg-white rounded-xl shadow p-3"
                >
                  <div className="grid grid-cols-1 md:grid-cols-8">
                    <button
                      onClick={() => toggle(entity.entite_id)}
                      className="flex-1 text-left flex flex-wrap items-center gap-3 col-span-5"
                      title="Ouvrir / fermer"
                    >
                      <span className="inline-block w-5 text-slate-500">
                        {isOpen ? (
                          <ChevronDown strokeWidth={3} />
                        ) : (
                          <ChevronRight strokeWidth={3} />
                        )}
                      </span>
                      <p className="font-medium truncate">{entity.entite_libelle}</p>
                      <div>
                        <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 mr-1 rounded-full ring-2 ring-orange-300 bg-orange-100 text-slate-700 text-xs">
                          {entityUsers.length} {' rôle' + (entityUsers.length > 1 ? 's' : '')}
                        </span>{' '}
                        <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full ring-2 ring-purple-300 bg-purple-200 text-slate-700 text-xs">
                          {entityProfiles.length}{' '}
                          {' personne' + (entityProfiles.length > 1 ? 's' : '')}
                        </span>
                      </div>
                    </button>
                    <div className="col-span-3 flex justify-end gap-2">
                      <Button
                        onClick={() => {
                          setCreateUserOpen(true);
                          setCreateUserForm((f) => ({
                            ...f,
                            entity_libelle: entity.entite_libelle,
                            entity_id: entity.entite_id,
                            entity_etablissements: entity.etablissements,
                          }));
                        }}
                      >
                        <p className="ml-0.5">
                          <CirclePlus size={20} className="inline-block" />{' '}
                          <span className="hidden md:inline">Ajouter un </span>Rôle
                        </p>
                      </Button>
                      <Button
                        onClick={() => {
                          setCreateProfileOpen(true);
                          setCreateProfileForm((f) => ({
                            ...f,
                            entity_libelle: entity.entite_libelle,
                            entity_id: entity.entite_id,
                            entity_etablissements: entity.etablissements,
                          }));
                        }}
                      >
                        <p className="ml-0.5">
                          <CirclePlus size={20} className="inline-block" />{' '}
                          <span className="hidden md:inline">Ajouter une </span>Personne
                        </p>
                      </Button>
                    </div>
                  </div>
                  {isOpen && (
                    <div className="grid grid-cols-1">
                      <div className="mb-3 space-y-2 bg-orange-100 ring-1 ring-orange-300 rounded-xl shadow p-3">
                        <p className="font-medium">Rôles</p>
                        {entityUsers.length > 0 ? (
                          <UserCards userRows={entityUsers} entity={entity} />
                        ) : (
                          <p className="italic text-sm text-gray-600">
                            Aucun rôle lié à cette entité
                          </p>
                        )}
                      </div>
                      <div className="mb-3 space-y-2 bg-purple-100 ring-1 ring-purple-300 rounded-xl shadow p-3">
                        <p className="font-medium">Personnes</p>
                        {entityProfiles.length > 0 ? (
                          <ProfileCards profileRows={entityProfiles} entity={entity} />
                        ) : (
                          <p className="italic text-sm text-gray-600">
                            Aucune personne liée à cette entité
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="my-3 space-y-2 mt-8">
            <div className="px-4 pt-2 pb-2 items-center justify-between mb-3 flex">
              <h1 className="text-xl font-semibold">Gestion des Admins</h1>
              <div className="flex gap-2">
                <Button
                  onClick={() => {
                    setCreateAdminOpen(true);
                  }}
                >
                  <p className="ml-0.5">
                    <CirclePlus size={20} className="inline-block" /> Ajouter un Admin
                  </p>
                </Button>
              </div>
            </div>
            <AdminCards userRows={users.filter((u) => u.user_role === 'admin')} />
          </div>
          <AdminSettingsPanel />
        </>
      )}
    </PageLayout>
  );
}